/* global axios */
import ApiClient from '../ApiClient';

class WgptBotToolsAPI extends ApiClient {
  constructor(botId) {
    super(`bots/${botId}/tools`, { accountScoped: true, wgpt: true });
  }

  addFile(toolSetId, id, data) {
    return axios.post(`${this.url}/${toolSetId}/add_file/${id}`, data);
  }

  addTool(toolSetId, data) {
    return axios.post(`${this.url}/${toolSetId}/add_tool`, data);
  }

  cloneTool(toolSetId, id) {
    return axios.post(`${this.url}/${toolSetId}/clone_tool/${id}`);
  }

  deleteTool(toolSetId, id) {
    return axios.delete(`${this.url}/${toolSetId}/delete_tool/${id}`);
  }

  updateTool(toolSetId, id, data) {
    return axios.patch(`${this.url}/${toolSetId}/update_tool/${id}`, data);
  }

  testTool(toolSetId, data) {
    return axios.post(`${this.url}/${toolSetId}/test`, data);
  }

  async export(toolSetId) {
    const { data, headers } = await axios.get(
      `${this.url}/${toolSetId}/export`,
      { responseType: 'blob' }
    );

    let filename = 'toolset_export.wgpt';
    const contentDisposition = headers['content-disposition'];
    if (contentDisposition) {
      const filenameMatch = contentDisposition.match(
        /filename\*=UTF-8''([^;]+)/i
      );
      if (filenameMatch) {
        filename = decodeURIComponent(filenameMatch[1]);
      }
    }

    const file = new File([data], filename, {
      type: 'application/octet-stream',
    });
    return { data: file };
  }

  import(data) {
    return axios.post(`${this.url}/import`, data);
  }

  getExecutions(params = {}) {
    return axios.get(`${this.url}/executions`, { params });
  }
}

export default WgptBotToolsAPI;
